import { render, staticRenderFns } from "./IconExpandTable.vue?vue&type=template&id=8b848938&scoped=true&"
import script from "./IconExpandTable.vue?vue&type=script&lang=js&"
export * from "./IconExpandTable.vue?vue&type=script&lang=js&"
import style0 from "./IconExpandTable.vue?vue&type=style&index=0&id=8b848938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b848938",
  null
  
)

export default component.exports